import styled from '@emotion/styled';
import { colorPalette } from 'styles/partials/colors';

interface LabelProps {
  labelColor: string;
  labelFont: string;
  labelFontSize: string;
}

export const Container = styled.div({
  position: 'relative',
  margin: '1rem 4px',
});

export const Textfield = styled.input({
  alignSelf: 'stretch',
  backgroundColor: 'transparent',
  border: `1px solid ${colorPalette.paragraphBaseline}`,
  borderRadius: '8px',
  color: colorPalette.paragraphBaseline,
  padding: '12px 16px',
  transition: 'border-color 250ms',
  width: '100%',

  '&::placeholder': {
    color: colorPalette.paragraphPlaceholder,
  },

  '&::-webkit-contacts-auto-fill-button': {
    visibility: 'hidden',
    pointerEvents: 'none',
    position: 'absolute',
  },
});

export const Label = styled.label<LabelProps>(
  {
    position: 'absolute',
    top: '12px',
    backgroundColor: 'white',
    padding: '0 8px',
    left: '16px',
    pointerEvents: 'none',
    transformOrigin: 'left center',
    transform: 'translateY(-105%) scale(0.75)',
  },
  props => ({
    color: props.labelColor,
    fontFamily: props.labelFont,
    fontSize: props.labelFontSize,
  })
);
